"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSend3 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconSend3 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.126 12.6649C22.3332 12.2459 22.3332 11.7543 22.126 11.3353C21.9436 10.9663 21.6235 10.7729 21.4576 10.6795C21.2791 10.5791 21.0503 10.4761 20.8221 10.3735L4.03833 2.82085C3.8049 2.71576 3.57218 2.61099 3.37587 2.54299C3.19564 2.48056 2.83277 2.36649 2.431 2.47828C1.97699 2.60461 1.60873 2.93697 1.43666 3.3757C1.2844 3.76393 1.36078 4.13656 1.40447 4.32223C1.45205 4.52448 1.5325 4.76673 1.61319 5.0097L3.23767 9.90402C3.36847 10.2981 3.43387 10.4951 3.55548 10.6408C3.66287 10.7695 3.80088 10.8691 3.95681 10.9305C4.13339 11 4.341 11 4.75621 11H11.9999C12.5522 11 12.9999 11.4477 12.9999 12C12.9999 12.5523 12.5522 13 11.9999 13H4.77512C4.36096 13 4.15387 13 3.97761 13.0692C3.82195 13.1304 3.68412 13.2296 3.57672 13.3578C3.4551 13.503 3.38936 13.6993 3.25788 14.0921L1.62033 18.9836C1.53876 19.2272 1.45752 19.4697 1.40932 19.6722C1.36513 19.8578 1.28747 20.2311 1.43932 20.6203C1.6108 21.0599 1.97909 21.3931 2.43353 21.52C2.83596 21.6323 3.19965 21.5178 3.37994 21.4553C3.57664 21.3872 3.80993 21.2822 4.04413 21.1767L20.8221 13.6267C21.0502 13.524 21.2791 13.4211 21.4577 13.3206C21.6235 13.2273 21.9436 13.0338 22.126 12.6649Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.5004 12H5.00043M4.91577 12.2915L2.58085 19.2662C2.39742 19.8142 2.3057 20.0881 2.37152 20.2569C2.42868 20.4034 2.55144 20.5145 2.70292 20.5567C2.87736 20.6054 3.14083 20.4869 3.66776 20.2497L20.3792 12.7296C20.8936 12.4981 21.1507 12.3824 21.2302 12.2216C21.2993 12.082 21.2993 11.9181 21.2302 11.7784C21.1507 11.6177 20.8936 11.5019 20.3792 11.2705L3.66193 3.74776C3.13659 3.51135 2.87392 3.39315 2.69966 3.44164C2.54832 3.48375 2.42556 3.59454 2.36821 3.74078C2.30216 3.90917 2.3929 4.18255 2.57437 4.72931L4.91642 11.7856C4.94759 11.8795 4.96317 11.9264 4.96933 11.9744C4.97479 12.0171 4.97473 12.0602 4.96916 12.1028C4.96289 12.1508 4.94718 12.1977 4.91577 12.2915Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconSend3 = IconSend3;
//# sourceMappingURL=IconSend3.js.map